import { CSSProperties, ReactNode } from "react";
import { Box, useMediaQuery } from "@mui/material";

import { useTypedTheme } from "hooks";

type Props = {
  children: ReactNode;
  columnNumber?: number;
  styleProps?: CSSProperties;
  notColumnOnMobile?: boolean;
};
export const Grid = ({ children, columnNumber }: Props) => {
  // styles
  const {
    theme: {
      breakpoints: { down },
    },
  } = useTypedTheme();
  const isMobile = useMediaQuery(down("md"));

  const columnsStyle = columnNumber
    ? "1fr ".repeat(columnNumber).trim()
    : "1fr 1fr";

  return (
    <Box
      sx={{
        display: ["flex", "grid"], //match ?  : 'grid',
        flexDirection: "column",
        gridTemplateRows: "auto auto auto",
        gridAutoFlow: "column",
        gridTemplateColumns: columnsStyle,
        columnGap: [2, 3, 3, 3],
        gap: !isMobile ? 0.7 : 1,
      }}
    >
      {children}
    </Box>
  );
};
